module.exports = __webpack_public_path__ + "static/img/questionnaire3.1dfc06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/questionnaire3.png
// module id = 5D2S
// module chunks = 1